import { usePaywallCheckoutContext } from "@circle-react/contexts/Paywalls/paywallCheckoutContext";
import type { CheckoutContextProps } from "@circle-react/contexts/Paywalls/paywallCheckoutContext";

import {
  getPaywallTitle,
  getPaywallDescription,
} from "../../../helpers/paywalls";
import { PaywallCustomization } from "../PaywallCustomization";
import { EventDetails } from "./EventDetails";
import { PaywallDescription } from "./PaywallDescription";
import { PaywallDetailContainer } from "./PaywallDetailContainer";
import { Title } from "./Title";

interface PaywallDetailProps {
  useHooks?: () => Pick<CheckoutContextProps, "paywall">;
}

export const PaywallDetail = Object.assign(
  ({ useHooks = usePaywallCheckoutContext }: PaywallDetailProps) => {
    const { paywall } = useHooks();

    const title = getPaywallTitle(paywall);
    const description = getPaywallDescription(paywall);

    return (
      <PaywallDetailContainer>
        <Title title={title} />
        <EventDetails event={paywall.event} />
        <PaywallDescription description={description} />
        <PaywallCustomization.Badges />
      </PaywallDetailContainer>
    );
  },
  {
    Upsell: ({ useHooks = usePaywallCheckoutContext }: PaywallDetailProps) => {
      const { paywall } = useHooks();

      const title = getPaywallTitle(paywall);
      const description = getPaywallDescription(paywall);

      return (
        <PaywallDetailContainer>
          <Title title={title} />
          <EventDetails event={paywall.event} />
          <PaywallDescription description={description} />
        </PaywallDetailContainer>
      );
    },
  },
);
